import React from 'react';
import { FaSyncAlt, FaTrashAlt, FaPlay, FaDice, FaRobot } from 'react-icons/fa';
import {
  TechShell, TechPageHeader, TechButton, TechButtonGhost,
  StatusPill,
} from '../../styles/techComponents';
import { Banner } from './CreadorPerfilesStyles';
import BloqueCredenciales from './BloqueCredenciales';
import BloqueCerebroIA from './BloqueCerebroIA';
import BloqueAntiBan from './BloqueAntiBan';
import BloqueGeneradorAleatorio from './BloqueGeneradorAleatorio';
import BloqueCuentasReales from './BloqueCuentasReales';
import TarjetaPerfil from './TarjetaPerfil';
import StepProgress from '../common/StepProgress';
import PreviewModal from './PreviewModal';
import useCreadorPerfiles from './useCreadorPerfiles';

const CreadorPerfiles = () => {
  const {
    platform, setPlatform,
    username, setUsername,
    password, setPassword,
    cookies, setCookies,
    proxy, setProxy,
    promptPersonalidad, setPromptPersonalidad,
    intereses, toggleInteres,
    frecuenciaPosteo, setFrecuenciaPosteo,
    tasaInteraccion, setTasaInteraccion,
    maxLikes, setMaxLikes,
    maxPosts, setMaxPosts,
    zonaHoraria, setZonaHoraria,
    horaInicioSueno, setHoraInicioSueno,
    horaFinSueno, setHoraFinSueno,
    saving,
    savedProfile, setSavedProfile,
    feedback, setFeedback,
    batchAccounts, batchResult, batchBusy,
    fileRef,
    platformMeta,
    resetForm,
    handleSaveAndVerify,
    handleGenerateAndCreate,
    handleFileSelect,
    handleBatchUpload,
    randomPlatform, setRandomPlatform,
    randomCount, setRandomCount,
    randomSeed, setRandomSeed,
    randomApplyBase, setRandomApplyBase,
    randomGender, setRandomGender,
    randomCountry, setRandomCountry,
    randomEmailDomain, setRandomEmailDomain,
    randomBusy, randomResult,
    handleGenerateRandom,
    // Preview modal
    previewProfiles,
    previewOpen, setPreviewOpen,
    handleConfirmCreateFromPreview,
    autoRegBusy, autoRegResult,
    handleAutoRegister,
    autoRegSteps, autoRegStepStatus,
  } = useCreadorPerfiles();

  return (
    <TechShell>
      <TechPageHeader
        title="Creator Lab"
        subtitle="Configura cuentas de redes sociales con personalidad de IA."
        dossier="DIGI://CREATOR-LAB"
        actions={
          <>
            <TechButton
              type="button"
              onClick={handleGenerateAndCreate}
              disabled={saving}
              style={{ marginRight: '0.6rem' }}
            >
              {saving ? <><FaSyncAlt /> Procesando...</> : <><FaDice /> Generar todo + Crear</>}
            </TechButton>
            <TechButtonGhost type="button" onClick={resetForm} disabled={saving}>
              <FaTrashAlt /> Limpiar
            </TechButtonGhost>
          </>
        }
      >
        <StatusPill>Perfiles IA <strong>v2.0</strong></StatusPill>
      </TechPageHeader>
      <BloqueCredenciales
        platform={platform} setPlatform={setPlatform}
        username={username} setUsername={setUsername}
        password={password} setPassword={setPassword}
        cookies={cookies} setCookies={setCookies}
        proxy={proxy} setProxy={setProxy}
        platformMeta={platformMeta}
        batchAccounts={batchAccounts} batchResult={batchResult}
        batchBusy={batchBusy}
        handleBatchUpload={handleBatchUpload}
        handleFileSelect={handleFileSelect}
        fileRef={fileRef}
      />
      <BloqueCerebroIA
        promptPersonalidad={promptPersonalidad}
        setPromptPersonalidad={setPromptPersonalidad}
        frecuenciaPosteo={frecuenciaPosteo}
        setFrecuenciaPosteo={setFrecuenciaPosteo}
        tasaInteraccion={tasaInteraccion}
        setTasaInteraccion={setTasaInteraccion}
        intereses={intereses}
        toggleInteres={toggleInteres}
      />
      <BloqueAntiBan
        maxLikes={maxLikes} setMaxLikes={setMaxLikes}
        maxPosts={maxPosts} setMaxPosts={setMaxPosts}
        zonaHoraria={zonaHoraria} setZonaHoraria={setZonaHoraria}
        horaInicioSueno={horaInicioSueno} setHoraInicioSueno={setHoraInicioSueno}
        horaFinSueno={horaFinSueno} setHoraFinSueno={setHoraFinSueno}
      />
      <BloqueGeneradorAleatorio
        randomPlatform={randomPlatform} setRandomPlatform={setRandomPlatform}
        randomCount={randomCount} setRandomCount={setRandomCount}
        randomSeed={randomSeed} setRandomSeed={setRandomSeed}
        randomApplyBase={randomApplyBase} setRandomApplyBase={setRandomApplyBase}
        randomGender={randomGender} setRandomGender={setRandomGender}
        randomCountry={randomCountry} setRandomCountry={setRandomCountry}
        randomEmailDomain={randomEmailDomain} setRandomEmailDomain={setRandomEmailDomain}
        randomBusy={randomBusy} randomResult={randomResult}
        handleGenerateRandom={handleGenerateRandom}
      />
      <BloqueCuentasReales
        autoRegBusy={autoRegBusy}
        autoRegResult={autoRegResult}
        autoRegSteps={autoRegSteps}
        autoRegStepStatus={autoRegStepStatus}
        handleAutoRegister={handleAutoRegister}
      />
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <TechButton
          type="button"
          onClick={handleSaveAndVerify}
          disabled={saving || !username.trim()}
          style={{ padding: '0.75rem 2.5rem', fontSize: '0.95rem' }}
        >
          {saving ? <><FaSyncAlt /> Guardando...</> : <><FaPlay /> Verificar y Guardar Perfil</>}
        </TechButton>
        <TechButtonGhost
          type="button"
          onClick={() => {
            const c = window.prompt('Cuantas cuentas de X registrar automaticamente? (1-5)', '1');
            if (c) handleAutoRegister(Math.min(Math.max(parseInt(c, 10) || 1, 1), 5));
          }}
          disabled={autoRegBusy}
          style={{ padding: '0.75rem 1.5rem', fontSize: '0.85rem' }}
        >
          {autoRegBusy ? <><FaSyncAlt /> Registrando...</> : <><FaRobot /> Auto-registrar en X</>}
        </TechButtonGhost>
      </div>
      {(autoRegBusy || autoRegSteps.length > 0) && (
        <div style={{ maxWidth: 480, margin: '0 auto 1rem', padding: '0.8rem 1rem', background: 'var(--panel-bg)', borderRadius: 8, border: '1px solid var(--border-soft)' }}>
          <div style={{ fontSize: '0.8rem', fontWeight: 600, marginBottom: 8, color: 'var(--text-secondary)' }}>
            {autoRegBusy ? 'Auto-registro en progreso...' : 'Resumen del proceso:'}
          </div>
          <StepProgress steps={autoRegSteps} status={autoRegStepStatus} />
        </div>
      )}
      {autoRegResult && (
        <Banner $ok={autoRegResult.ok}>
          {autoRegResult.ok
            ? `Creadas: ${autoRegResult.created} | Fallidas: ${autoRegResult.failed}`
            : (autoRegResult.error || 'Error en auto-registro')}
          {autoRegResult.results?.map((r, i) => (
            <div key={i} style={{ fontSize: '0.75rem', marginTop: 4 }}>
              #{i + 1} {r.ok ? `\u2713 @${r.username} (${r.email})` : `\u2717 ${r.error}`}
            </div>
          ))}
        </Banner>
      )}
      {feedback && (
        <Banner $ok={feedback.type === 'success'}>{feedback.message}</Banner>
      )}
      <TarjetaPerfil
        savedProfile={savedProfile}
        platformMeta={platformMeta}
        setSavedProfile={setSavedProfile}
        setFeedback={setFeedback}
      />
      <PreviewModal
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
        profiles={previewProfiles}
        platform={randomPlatform}
        onConfirm={handleConfirmCreateFromPreview}
        onCancel={() => setPreviewOpen(false)}
        isLoading={randomBusy}
      />
    </TechShell>
  );
};

export default CreadorPerfiles;
